export default function PlusIcon ({ minus }) {
  return (
    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.25 5.25781H10.25" stroke="currentColor"/>
      {!minus && <path d="M5.14062 0L5.14063 10" stroke="currentColor"/>}
    </svg>
  )
}
